export const environment = {
    production: true,
    baseApiUrl: 'https://api.live.baytekgames.com/api',
    defaultImageBucket: 'prizehublive-defaults',
    name: 'production'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts